export default __webpack_public_path__ + "static/media/headerLogo.045de2e9.svg";